import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Loginform }        from './components/Loginform';
import RegisterPage         from './Pages/RegisterPage';
import ForgotPasswordPage   from './Pages/ForgotPasswordPage';
import VerifyEmailPage      from './Pages/VerifyEmailPage';
import Dashboard            from './Pages/Dashboard';
import Layout               from './components/Layout';
import LeadsPage            from './Pages/LeadsPage';
import LeadDetailPage       from './Pages/LeadDetailPage';
import PropertyPage         from './Pages/PropertyPage';
import SiteVisitPage        from './Pages/SiteVisitPage';
import DealsPage            from './Pages/DealsPage';
import LeadsAdminTable      from './components/leads/LeadAdminTable';
import Payments             from './Pages/PaymentPage';
import Documents            from './Pages/DocumentPage';
import PropertyDetails      from './components/properties/PropertyDetails';
import SiteVisitDetails     from './components/siteVisit/SiteVisitDetails';
import AnalyticsPage        from './Pages/AnalyticsPage';
import CallLogPage          from './Pages/CallLogPage';
import MISPage              from './Pages/MISPage';
import CallLogDetailPage    from './Pages/CallLogDetailPage';
import TaskPage             from './Pages/TaskPage';
import UserManagement       from './Pages/UserManagement';
import ReportsDigestPage    from './Pages/ReportsDigestPage';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* ── Public auth routes ── */}
        <Route path="/"                element={<Loginform />} />
        <Route path="/register"        element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-email"    element={<VerifyEmailPage />} />

        {/* ── Protected app routes ── */}
        <Route element={<Layout />}>
          <Route path="/dashboard"        element={<Dashboard />} />
          <Route path="/leads"            element={<LeadsPage />} />
          <Route path="/leads/:id"        element={<LeadDetailPage />} />
          <Route path="/leads-table"      element={<LeadsAdminTable />} />
          <Route path="/properties"       element={<PropertyPage />} />
          <Route path="/properties/:id"   element={<PropertyDetails />} />
          <Route path="/site-visits"      element={<SiteVisitPage />} />
          <Route path="/site-visits/:id"  element={<SiteVisitDetails />} />
          <Route path="/deals"            element={<DealsPage />} />
          <Route path="/analytics"        element={<AnalyticsPage />} />
          <Route path="/payments"         element={<Payments />} />
          <Route path="/documents"        element={<Documents />} />
          <Route path="/call-logs"        element={<CallLogPage />} />
          <Route path="/call-logs/:id"    element={<CallLogDetailPage />} />
          <Route path="/mis"              element={<MISPage />} />
          <Route path="/reports-digest"   element={<ReportsDigestPage />} />
          <Route path="/tasks"            element={<TaskPage />} />
          <Route path="/users"            element={<UserManagement />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
